import React from "react";
import cx from "clsx";
import { Row, Col } from "react-grid-system";

// import InstagramIcon from "@/images/shared/instagram-icon.svg";
// import FacebookIcon from "@/images/shared/facebook-icon.svg";
import CushmanLogo from "@/images/footer/Cushman-Wakefield.svg";
import GreystarLogo from "@/images/footer/Greystar.svg";
import { LINKS } from "./constants";

import globalStyles from "@/styles/global.module.scss";
import footerStyles from "./footer.module.scss";
import styles from "./mobile-footer.module.scss";

// const legalPDF = !process.env.STORYBOOK_DEV
//   ? require.context("@/downloadable", true)
//   : () => "";

const year = new Date().getFullYear();

const MobileFooter = props => {
  const { onNavLinkClick, userIsTabbing } = props;

  return (
    <div
      className={cx(
        globalStyles.contentPaddingH,
        userIsTabbing && globalStyles.userIsTabbing,
        footerStyles.container,
        styles.container
      )}
    >
      <div className={cx(footerStyles.links, styles.links)}>
        {LINKS.map((item, index) => {
          return (
            <div
              key={`footer-${item.label}`}
              className={cx(
                footerStyles.linkContainer,
                styles.linkContainer,
                index >= LINKS.length - 2 && styles.last
              )}
            >
              <button
                className={cx(
                  globalStyles.buttonReset,
                  footerStyles.link,
                  styles.link
                )}
                onClick={onNavLinkClick(item)}
              >
                {item.label}
              </button>
            </div>
          );
        })}
      </div>

      <div className={styles.socialContainer}>
        <div className={footerStyles.socialIcon}>
          {/*<a
            href="https://facebook.com/"
            target="_blank"
            rel="noreferrer"
            title="Facebook"
          >
            <FacebookIcon alt="Facebook" className={globalStyles.image} />
          </a>*/}
        </div>
        <div className={footerStyles.socialIcon}>
          {/*<a
            href="https://instagram.com/"
            target="_blank"
            rel="noreferrer"
            title="Instagram"
          >
            <InstagramIcon alt="Instagram" className={globalStyles.image} />
          </a>*/}
        </div>
      </div>

      <div className={cx(globalStyles.slashContainer, styles.slashContainer)}>
        <div className={globalStyles.verticalSlash} />
      </div>

      <Row className={styles.peopleRow} gutterWidth={30}>
        <div className={cx(footerStyles.people, styles.people)}>
          <Col xs={6} className={styles.peopleCol}>
            <div className={cx(styles.person, styles.first)}>
              <div className={footerStyles.personLabel}>Ben Paul</div>
              <div className={footerStyles.personStat}>Lic #01210872</div>
              <div className={footerStyles.personStat}>+1 (650) 401-2123</div>
              <div className={footerStyles.personStat}>
                <a
                  href="mailto:ben.paul@cushwake.com"
                  target="_blank"
                  rel="noreferrer"
                  title="email"
                >
                  ben.paul@cushwake.com
                </a>
              </div>
            </div>
          </Col>
          <Col xs={6} className={styles.peopleCol}>
            <div className={cx(styles.person, styles.second)}>
              <div className={footerStyles.personLabel}>David Hiebert</div>
              <div className={footerStyles.personStat}>Lic #1189320</div>
              <div className={footerStyles.personStat}>+1 (650) 320-0250</div>
              <div className={footerStyles.personStat}>
                <a
                  href="mailto:david.hiebert@cushwake.com"
                  target="_blank"
                  rel="noreferrer"
                  title="email"
                >
                  david.hiebert@cushwake.com
                </a>
              </div>
            </div>
          </Col>
        </div>
      </Row>

      <div className={cx(globalStyles.row, styles.logos)}>
        <div className={cx(styles.logo, footerStyles.cushmanLogo)}>
          <CushmanLogo width={120} height={25} alt="Cushman Wakefield" />
        </div>
        <div className={styles.logo}>
          <GreystarLogo alt="Greystar" />
        </div>
      </div>

      <div className={cx(globalStyles.row, styles.legalLinks)}>
        <div
          className={cx(footerStyles.legalLink, styles.legalLink)}
        >{`©${year} Greystar`}</div>
        <a
          href="/"
          target="_blank"
          rel="noreferrer"
          className={cx(footerStyles.legalLink, styles.legalLink)}
          title="Privacy policy"
        >
          Privacy Policy
        </a>
        <a
          href="/"
          target="_blank"
          rel="noreferrer"
          className={cx(footerStyles.legalLink, styles.legalLink)}
          title="Terms and conditions"
        >
          Terms & Conditions
        </a>
      </div>
    </div>
  );
};

export default MobileFooter;
